import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { TestimonialRow } from './testimonial-row';
import { ITestimonial } from '../types';

interface Props {
  tableProps: TableProps;
  rows?: ITestimonial[];
  loading?: boolean;
  canAddTestimonial?: string;
}

const TestimonialList = ({ tableProps, rows, loading, canAddTestimonial }: Props) => {
  const TABLE_HEAD = [
    { id: 'clientId', label: 'Id', align: 'center' },
    { id: 'clientName', label: 'Client Name', align: 'center' },
    { id: 'projectName', label: 'Project Name', align: 'center' },
    { id: 'feedback', label: 'Feedback', align: 'center', sortable: false },
    ...(canAddTestimonial
      ? [{ id: 'Action', label: 'Action', align: 'center', sortable: false }]
      : []),
  ];
  return (
    <PaginatedTable<ITestimonial>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <TestimonialRow
          row={row}
          canAddTestimonial={canAddTestimonial}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};
export { TestimonialList };
